/**
 * src/config/hostname.js
 * Centralized hostname configuration with per-service URL overrides.
 *
 * Priority (highest to lowest):
 * 1. Explicit per-service variable (e.g., REACT_APP_API_URL)
 * 2. Derived from REACT_APP_BASE_HOSTNAME
 * 3. Hardcoded default (voipbin.net)
 */

const getEnv = (key) => {
  const runtimeEnv = typeof window !== 'undefined' ? window._env_ : undefined;
  return runtimeEnv?.[key];
};

export const getBaseHostname = () => {
  return getEnv('REACT_APP_BASE_HOSTNAME') || 'voipbin.net';
};

export const getApiUrl = () => {
  const override = getEnv('REACT_APP_API_URL');
  if (override) return override;
  return `https://api.${getBaseHostname()}/`;
};

export const getWebSocketUrl = () => {
  const override = getEnv('REACT_APP_WEBSOCKET_URL');
  if (override) return override;
  return `wss://api.${getBaseHostname()}/v1.0/ws`;
};

// NOTE: There is intentionally no registrar-domain helper here. The
// customer SIP domain (realm) is never constructed client-side - it comes
// verbatim from the extension API's `domain_name` field (VOIP-1385).

export const getSipDomain = () => {
  const override = getEnv('REACT_APP_SIP_DOMAIN');
  if (override) return override;
  return `sip.${getBaseHostname()}`;
};

export const getSipWssUrl = () => {
  const override = getEnv('REACT_APP_SIP_WSS_URL');
  if (override) return override;
  return `wss://sip.${getBaseHostname()}`;
};
